import { Dayjs, PluginFunc, UnitType, ManipulateType } from 'dayjs';

declare module 'dayjs' {
  interface Dayjs {
    ceil(amount: number, unit: string): Dayjs;
  }
}

const ceil: PluginFunc = (option, dayjsClass) => {
  dayjsClass.prototype.ceil = function (amount: number, unit: string): Dayjs {
    return this.add(amount - (this.get(unit as UnitType) % amount), unit as ManipulateType).startOf(unit as ManipulateType);
  };
};

export default ceil; 